 
 
import axios from '../api/axiosSettings.js';
import useAuth from './useAuth.js';

const useRefreshToken = () => {
    const { setAuth } = useAuth();
    const refresh = async () => {

        try {

            console.log("AXIOS refresh token  : ");
            var finalIP = "";

            finalIP = "https://stepupkorea.kr/api/refresh";

            const response = await axios.get(finalIP,
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true,
                    credentials: 'include'
                }
            );
            if (response) {
                setAuth(prev => {
                    console.log("prev:: ", JSON.stringify(prev));
                    console.log("accessToken:: ", response.data.accessToken);
                    return {
                        ...prev,
                        //roles: response.data.roles,
                        accessToken: response.data.accessToken
                    }
                });
                return response.data.accessToken;
            }
        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else {
                console.log('ERR');
            }

        }
    }
    return refresh;
};

export default useRefreshToken;
